require('./vendor/form-tags')

// Create tagTypes
window.tagTypes = ['artist', 'circle', 'parody', 'content', 'category', 'character', 'collection', 'language', 'scanlator', 'convention'];

var Pururin = {
    listInfo: false,
    infiniScrollLoading: false,
    triggerScroll: true,
    scrolled: false,
    init: function () {
        var self = this;
        this.tagsInputInit();
        this.overlay();
        this.initInfinitScroll();
        this.browseSaver($('.row-gallery'));
        this.browseSetter();
        this.advanceSearch();
        $('img.lazy').lazy();
        $('.list-overlay-toggle').on('click', function (e) {
            e.preventDefault();
            if (!self.listInfo) {
                $('.card-gallery > .meta').css('bottom', 0);
                self.listInfo = true;
            } else {
                $('.card-gallery > .meta').css('bottom', -58);
                self.listInfo = false;
            }
        })
        $('.notification-read').on('click', function (e) {
            e.preventDefault();
            self.markNotificationAsRead();
        });
        $('.page-goto').on('click', function (e) {
            var page = parseInt(prompt('Jump page to?'));
            if (page > 0) {
                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);
                params.set('page', page);
                url.search = params.toString();
                window.location = url.toString();
            }
        });
    },
    overlay: function () {
        var self = this;
        $('.card-gallery').hoverIntent({
            over: function () {
                if (self.listInfo) return;
                var anim = $(this).find('.meta');
                anim.stop(true).delay(0).animate({
                    bottom: '0px'
                }, 0)
            },
            out: function () {
                if (self.listInfo) return;
                var anim = $(this).find('.meta');
                anim.stop(true).delay(0).animate({
                    bottom: '-58px'
                }, 0);
            },
            timeout: 500,
            sensitivity: 3,
            interval: 175
        });
    },
    markNotificationAsRead: function () {
        $('.modal-body .notifications').html('<div class="text-center m-2">You have no new notifications</div>');
        $('.notification').removeClass('active');
        axios.post('/account/notifications', {
            unread: true,
        }).catch(e => {
            PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
        })
    },
    tagsInputInit: function () {
        for (const type of tagTypes) {
            $('input[name="' + type + '_tags"]').formTags({
                withNew: (type === 'content') ? false : true,
                search: (query) => {
                    return new Promise((resolve, reject) => {
                        axios.post('/api/get/tags', {
                            type: type,
                            text: query,
                        }).then((resp) => {
                            resolve(resp.data);
                        }).catch(e => reject(e))
                    });
                }
            });
        }
    },
    initInfinitScroll: function () {
        var row = $('.row-gallery');
        if (row.length <= 0) return;
        if (row.hasClass('row-gallery-small') || !row.data('current-page') || !row.data('last-page')) return;
        if (!PururinSetting.get('settings-listInfiniScroll')) return;
        $('link[rel="next"]').remove();
        $('link[rel="prev"]').remove();
        $(window).scroll(() => {
            this.infiniteScroll();
        })
        this.infiniteScroll();
    },
    infiniteScroll: function () {
        if (!PururinSetting.get('settings-listInfiniScroll')) return;
        var row = $('.row-gallery');
        if (row.length <= 0) return;
        if (row.hasClass('row-gallery-small')) return;
        if (row.hasClass('row-gallery-small') || !row.data('current-page') || !row.data('last-page')) return;
        var fromBottom = 300;
        if (!this.triggerScroll) return;
        if (this.infiniScrollLoading) return;
        if ($(window).scrollTop() + $(window).height() >= row.height() + row.offset().top - fromBottom) {
            var data = row.data();
            if (data.currentPage == data.lastPage) {
                this.triggerScroll = false;
            }
            this.infiniScrollLoading = true;
            var page = data.currentPage + 1;
            if (page > data.lastPage) {
                this.triggerScroll = false;
                this.infiniScrollLoading = false;
                return;
            }
            row.append('<div id="list-loading" class="box text-center"><img src="/assets/images/252.gif"></div>')
            axios.get(window.location.href, {
                params: {
                    page: page,
                    scroll: true,
                }
            }).then(resp => {
                row.data('current-page', page);
                row.data('url', this.getScrollCurrentURL(page))
                row.append(resp.data);
                this.scrollTop(row);
                this.skipPage(row);
                this.browseSaver(row);
                $('.pagination').addClass('d-none');
                $('#list-loading', row).remove();
                this.infiniScrollLoading = false;
            }).catch(e => {
                this.infiniScrollLoading = false;
            });
        }
    },
    scrollTop: function (scope) {
        $('.scroll-top', scope).off('click').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 500);
            return false;
        });
    },
    skipPage: function (scope) {
        $('.skip', scope).off('click').on('click', function (e) {
            e.preventDefault();
            var data = $('.row-gallery').data();
            var page = prompt(`Go to page: (max: ${data.lastPage})`, data.currentPage)
            if (!page) return false;
            page = Math.max(0, Math.min(data.lastPage, page));
            if (page != data.currentPage) {
                var url = new URL(window.location.href);
                var searchParams = url.searchParams;
                if (searchParams.has('page')) {
                    searchParams.set('page', page);
                } else {
                    searchParams.append('page', page);
                }
                url.search = searchParams.toString();
                document.location = url.toString();
            }
            return false;
        });
    },
    getScrollCurrentURL: function (page) {
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);
        params.set('page', page);
        return `${url.protocol}//${url.host + url.pathname}?${params}`;
    },
    browseSaver: function (scope) {
        $('a[data-gid]', scope).off('click').on('click', function (e) {
            var id = $(this).data('gid');
            if (!id);
            var href = $(this).prevAll('div.box:first').find('a.infinite-href').attr('href') || window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search;
            if (!href) return;
            localStorage.setItem('listLink', href + '#G' + id);
        });
    },
    browseSetter: function () {
        var linkOverview = $('.page-overview');
        var listLink = localStorage.getItem('listLink');
        if (listLink !== null) {
            linkOverview.attr('href', listLink)
            return;
        }
        linkOverview.remove();
    },
    advanceSearch: function () {
        for (const input of ['input[name="included_tags"]', 'input[name="excluded_tags"]']) {
            $(input).formTags({
                withNew: false,
                search: (query) => {
                    return new Promise((resolve, reject) => {
                        axios.post('/api/get/tags/search', {
                            text: query,
                        }).then((resp) => {
                            resolve(resp.data);
                        }).catch(e => reject(e))
                    });
                }
            });
        }
        // On submit
        $('form[id="search-form"]').on('submit', function (e) {
            $(this).find('button[type="submit"]').attr('disabled', 'disabled');
            try {
                if ($(this).find('select[name="condition"]').val() === 'contains_with') $(this).find('select[name="condition"]').attr('disabled', 'disabled');
                if ($(this).find('select[name="tag_condition"]').val() === 'must_have') $(this).find('select[name="tag_condition"]').attr('disabled', 'disabled');
                if ($(this).find('input[name="start_page"]').val() == 1) $(this).find('input[name="start_page"]').attr('disabled', 'disabled');
                if ($(this).find('input[name="last_page"]').val() == 9999) $(this).find('input[name="last_page"]').attr('disabled', 'disabled');
                if ($(this).find('input[name="included_tags"]').val() == "[]") $(this).find('input[name="included_tags"]').attr('disabled', 'disabled');
                if ($(this).find('input[name="excluded_tags"]').val() == "[]") $(this).find('input[name="excluded_tags"]').attr('disabled', 'disabled');
            } catch (e) {}
        });
    }
}

var PururinMenu = {
    init: function () {
        if (!this.isTouch()) return;
        $('body').addClass('touch-device');
        $('.dropdown-toggle').on('click', function (event) {
            event.preventDefault();
            $('.dropdown-menu').not($(this).next('.dropdown-menu')).slideUp();
            $(this).next('.dropdown-menu').slideToggle();
        });
    },
    isTouch: function () {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    }
}

var PururinHotkey = {
    scrollPress: false,
    scrollCode: false,
    doctitle: false,
    init: function () {
        var self = this;
        window.addEventListener('keyup', function () {
            if (!PururinSetting.get('settings-useHotkeys')) return;
            self.scrollCode = false;
        });
        window.addEventListener('keydown', function (e) {
            if (!PururinSetting.get('settings-useHotkeys')) return;
            if (e.altKey || e.ctrlKey || e.shiftKey) return;
            if ($('input:focus, textarea:focus').length != 0) return;
            var keyCode = e.keyCode || e.which;
            if (!keyCode) return;
            self.scrollCode = keyCode;
            if (keyCode == 39 || keyCode == 68) {
                self.next();
            } else if (keyCode == 37 || keyCode == 65) {
                self.prev();
            } else if (keyCode == 87 || keyCode == 38) {
                e.preventDefault();
                self.scroll(0, -1);
            } else if (keyCode == 83 || keyCode == 40) {
                e.preventDefault();
                self.scroll(0, 1);
            } else if (keyCode == 70) {
                e.preventDefault();
                self.focusSearch();
            } else if (keyCode == 88) {
                e.preventDefault();
                self.ohShit();
            } else if (keyCode == 90) {
                e.preventDefault();
                self.fitOrOverlay();
            }
        });
    },
    next: function () {
        var href = $('link[rel="next"]').attr('href')
        if (href) {
            window.location = href;
            return;
        }
        var imgNext = $('.img-next');
        if (imgNext.length != 0) {
            $(imgNext[0]).click();
            return;
        }
        return;
    },
    prev: function () {
        var href = $('link[rel="prev"]').attr('href')
        if (href) {
            window.location = href;
            return;
        }
        var imgPrev = $('.img-back');
        if (imgPrev.length != 0) {
            $(imgPrev[0]).click();
            return;
        }
        return;
    },
    focusSearch: function () {
        $('.searchAll').focus();
    },
    ohShit: function () {
        var body = $('body')
        if (body.hasClass('oh-shit')) {
            body.removeClass('oh-shit');
            document.title = this.doctitle;
        } else {
            body.addClass('oh-shit');
            this.doctitle = document.title;
            document.title = 'New Tab';
        }
    },
    fitOrOverlay: function () {
        var imgReader = $('.img-reader');
        if (imgReader.length != 0) {
            imgReader.toggleClass('fit-width');
            $('.container').toggleClass('fit-width');
        } else {
            if (!Pururin.listInfo) {
                $('.card-gallery > .meta').css('bottom', 0);
                Pururin.listInfo = true;
            } else {
                $('.card-gallery > .meta').css('bottom', -58);
                Pururin.listInfo = false;
            }
        }
    },
    scroll: function (x, y) {
        if (this.scrollPress) return;
        var key = this.scrollCode;
        this.scrollPress = setInterval(() => {
            window.scrollBy(x * 5, y * 5);
            if (this.scrollCode !== key) {
                clearInterval(this.scrollPress);
                this.scrollPress = false;
            }
        }, 5);
    },
}

var PururinSetting = {
    init: function () {
        var self = this;
        this.apply();
        $('.settings-save').each(function (e) {
            this.checked = self.get(this.id);
        });
        $('.settings-save').on('change', function (e) {
            self.set(this.id, this.checked);
            self.apply();
        });
    },
    apply: function () {
        // Apply white theme
        if (this.get('settings-polarBear')) {
            $('body').addClass('theme-white');
        } else {
            $('body.theme-white').removeClass('theme-white');
        }
        // Apply infinite scroll
        if (this.get('settings-listInfiniScroll')) {
            Pururin.initInfinitScroll();
        }
        // Apply show info
        if (this.get('settings-listAutoShow')) {
            $('.card-gallery > .meta').css('transition', '0s');
            $('.card-gallery > .meta').css('bottom', 0);
            Pururin.listInfo = true;
            setTimeout(() => {
                $('.card-gallery > .meta').css('transition', '0.4s');
            }, 400);
        } else {
            $('.card-gallery > .meta').css('transition', '0s');
            $('.card-gallery > .meta').css('bottom', -58);
            Pururin.listInfo = false;
            setTimeout(() => {
                $('.card-gallery > .meta').css('transition', '0.4s');
            }, 400);
        }
        // Apply image resize
        if (this.get('settings-resizeImages') && $('.img-reader').length != 0) {
            $('.img-reader').addClass('fit-width');
            $('.container').addClass('fit-width');
        } else if ($('.img-reader').length != 0) {
            $('.img-reader').removeClass('fit-width');
            $('.container').removeClass('fit-width');
        }
        // Apply swipe
        if (this.get('settings-useTouch')) {
            $(document).swipe({
                swipeLeft: () => {
                    this.get('settings-flipZone') ? PururinHotkey.prev() : PururinHotkey.next();
                },
                swipeRight: () => {
                    this.get('settings-flipZone') ? PururinHotkey.next() : PururinHotkey.prev();
                },
            });
        }
        // Apply image zone
        if (this.get('settings-enableZone')) {
            $('.img-back.zone').removeClass('d-none');
        } else {
            $('.img-back.zone').addClass('d-none');
        }
        // Apply manga style
        if (this.get('settings-flipZone')) {
            $('a.img-view-mode[data-mode="manga"]').click()
        } else {
            $('a.img-view-mode[data-mode="single"]').click()
        }
    },
    get: function (key) {
        var setting = localStorage.getItem(key);
        if (setting === null) return ['settings-useHotkeys', 'settings-preloadImages', 'settings-scrollHeader', 'settings-enableZone', 'settings-imageViewer'].includes(key)
        return setting === 'true';
    },
    set: function (key, value) {
        localStorage.setItem(key, value);
    }
}

var PururinRate = {
    init: function () {
        var self = this;
        $('.rating-rateable i').on('click', function (e) {
            self.click($(this));
        });
    },
    click: function (el) {
        var r = -($('.rating i').index(el) - 5);
        var gid = el.parent('.rating').data('gid');
        axios.post('/gallery/rate/' + gid, {
            rating: r,
        }).then((resp) => {
            $('.rating-rateable i').removeClass('rating-selected');
            el.addClass('rating-selected');
            $('.rating-text').text(resp.data.ratingText);
        }).catch(e => {
            PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
        });
    },
}

var PururinGallery = {
    init: function () {
        var self = this;
        $('.btn-favorite').on('click', function (e) {
            e.preventDefault();
            var gid = $(this).data('gid');
            self.collection($(this), gid, 'favorite');
        });
        $('.btn-bookmark').on('click', function (e) {
            e.preventDefault();
            var gid = $(this).data('gid');
            self.collection($(this), gid, 'bookmark');
        });
        $('.btn-preview-load-more').on('click', function (e) {
            e.preventDefault();
            var hidden = $('.gallery-preview a:hidden');
            hidden.slice(0, 16).show(0).removeClass('d-none').addClass('d-inline-block');
            if ($('.gallery-preview a:hidden').length == 0) {
                $(this).addClass('d-none');
                $('.btn-preview-view-all').addClass('d-none');
                $('.btn-preview-hide').removeClass('d-none');
            }
        });
        $('.btn-preview-view-all').on('click', function (e) {
            e.preventDefault();
            var hidden = $('.gallery-preview a:hidden');
            hidden.slice(0, hidden.length).show(0).removeClass('d-none').addClass('d-inline-block');
            if ($('.gallery-preview a:hidden').length == 0) {
                $(this).addClass('d-none');
                $('.btn-preview-load-more').addClass('d-none');
                $('.btn-preview-hide').removeClass('d-none');
            }
        });
        $('.btn-preview-hide').on('click', function (e) {
            e.preventDefault();
            $('.gallery-preview a').slice(-($('.gallery-preview a').length - 16)).removeClass('d-inline-block').addClass('d-none');
            $(this).addClass('d-none');
            $('.btn-preview-load-more').removeClass('d-none');
            $('.btn-preview-view-all').removeClass('d-none');
        });
    },
    collection: function (el, gid, type) {
        this.toggleLoading(el);
        axios.post('/gallery/collection/' + gid, {
            type: type,
        }).then((resp) => {
            this.toggleLoading(el);
            this.toggleIcon(el, type);
        }).catch(e => {
            this.toggleLoading(el);
            PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
        })
    },
    toggleLoading: function (el) {
        el.toggleClass('is-loading');
    },
    toggleIcon: function (el, type) {
        switch (type) {
            case 'favorite':
                el.toggleClass('is-fav')
                break;
            case 'bookmark':
                el.toggleClass('is-bm')
                break
            default:
                break;
        }
    }
}

var PururinTag = {
    init: function () {
        var self = this;
        $('.btn-like').on('click', function (e) {
            e.preventDefault();
            var tid = $(this).data('tid');
            self.collection($(this), tid, 'white-listed');
        })
        $('.btn-blacklist').on('click', function (e) {
            e.preventDefault();
            var tid = $(this).data('tid');
            self.collection($(this), tid, 'black-listed');
        })
    },
    collection: function (el, tid, type) {
        this.toggleLoading(el);
        axios.post('/tag/collection/' + tid, {
            type: type,
        }).then((resp) => {
            this.toggleLoading(el);
            this.toggleIcon(el, type);
        }).catch(e => {
            this.toggleLoading(el);
            PururinMessage.error(e.response.data.msg || e.response.data.message || e.message);
        })
    },
    toggleLoading: function (el) {
        el.toggleClass('is-loading');
    },
    toggleIcon: function (el, type) {
        switch (type) {
            case 'white-listed':
                el.toggleClass('is-like')
                break;
            case 'black-listed':
                el.toggleClass('is-blacklist')
                break
            default:
                break;
        }
    }
}

var PururinRead = {
    data: null,
    images: [],
    viewMode: PururinSetting.get('settings-flipZone') ? 'manga' : 'single',
    preloadPage: 0,
    init: function () {
        var self = this;
        self.data = $('.img-viewer').data();
        // Add to images
        for (var i = 1; i <= this.getTotalPages(); i++) {
            const img = document.createElement('img');
            img.className = 'img-fluid w-100';
            this.images[i] = img;
        }
        // Set preloadPage
        this.preloadPage = this.data.page - 1;
        // Preload images
        this.preload(6);
        // Events
        $('.img-next').on('click', function (e) {
            e.preventDefault();
            self.next();
        })
        $('.img-back').on('click', function (e) {
            e.preventDefault();
            self.prev();
        });
        $('.img-select').on('change', function () {
            window.location = $(this).val();
        });
        $('.img-view-mode').on('click', function (e) {
            e.preventDefault();
            self.viewMode = $(this).data('mode');
            self.update();
            self.setImage(self.data.page);
        });
        // Update image
        self.update();
        self.setImage(self.data.page);
    },
    preload: function (count) {
        if (!PururinSetting.get('settings-preloadImages')) return;
        for (var i = this.preloadPage + 1; i <= this.preloadPage + count; i++) {
            // Get the image
            var img = this.getImage(i)
            if (!img) return;
            // Update img src
            this.images[i].src = img
        }
        this.preloadPage += count;
    },
    next: function () {
        // Check if not imageViewer
        if (!PururinSetting.get('settings-imageViewer') && (href = $('.img-next').attr('href'))) {
            window.location.href = href;
            return;
        }
        this.reloadAds();
        // toggle image loading ui
        this.imgIsLoading();
        // update current page
        this.data.page += this.viewMode == 'single' ? 1 : 2;
        // Update
        this.update();
        // Update URL current page
        this.setImage(this.data.page);
        this.setCurrentPage(this.data.page);
        this.skipHeader();
        this.preload(this.viewMode == 'single' ? 1 : 2);
    },
    prev: function () {
        // Check if not imageViewer
        if (!PururinSetting.get('settings-imageViewer') && (href = $('.img-back').attr('href'))) {
            window.location.href = href;
            return;
        }
        this.reloadAds();
        // update current page
        this.data.page -= this.viewMode == 'single' ? 1 : 2;
        // Update
        this.update();
        // Update URL current page
        this.setImage(this.data.page);
        this.setCurrentPage(this.data.page);
        this.skipHeader();
    },
    getTotalPages: function () {
        return this.data.img.images.length;
    },
    setCurrentPage: function (page) {
        // Update url
        var currentURL = window.location.href;
        var updatedURL = currentURL.replace(/\/(\d+\/)(\d+)(\/)/, '/$1' + this.pagePadding(page) + '/');
        window.history.replaceState(null, '', updatedURL);
    },
    update: function () {
        try {
            // Back
            if (this.data.page == 1) {
                $('.img-back').attr('href', this.data.gallery)
            } else if (this.data.page <= 0) {
                window.location = this.data.gallery;
                return false;
            } else $('.img-back').attr('href', window.location.href.replace(/\/(\d+\/)(\d+)(\/)/, '/$1' + this.pagePadding(this.data.page - 1) + '/'));
            // Next
            if (this.data.page == this.getTotalPages()) {
                $('.img-next').attr('href', this.data.finish)
            } else if (this.data.page > this.getTotalPages()) {
                window.location = this.data.finish;
                return false;
            } else $('.img-next').attr('href', window.location.href.replace(/\/(\d+\/)(\d+)(\/)/, '/$1' + this.pagePadding(this.data.page + 1) + '/'));
            // Select
            $('.img-select').find('option[data-page="' + this.data.page + '"]').prop('selected', true);
            // Create pageText
            var pageText = (this.viewMode == 'single') ? `Page ${this.data.page}` : `Page ${this.data.page} & Page ${this.data.page + 1} (${this.viewMode.charAt(0).toUpperCase()}${this.viewMode.slice(1)} Style)`;
            // Update img menu title
            $('.img-menu h1 > span').text(pageText);
            // Update title
            document.title = document.title.replace(/(.+)\|/, `${pageText} |`);
            // Update breadcrumb
            $('.breadcrumb-item.active span').text(pageText);
        } catch (e) {
            console.log(e);
        }
    },
    getImage: function (page) {
        var img = this.data.img.images.find(img => img.page === page);
        if (!img) return null;
        return `${this.data.svr}/${this.data.img.directory}/${img.filename}`;
    },
    setImage: function (page) {
        var n = document.querySelector('.img-next');
        var currentImage = this.images[page];
        var nextImage = this.images[page + 1];
        // Update img src and class
        currentImage.className = 'img-fluid w-100';
        currentImage.src = this.getImage(page);
        currentImage.onload = () => {
            this.imgLoaded();
        };
        // Remove existing images from n
        while (n.firstChild) {
            n.removeChild(n.firstChild);
        }
        // Append currentImage to n
        n.appendChild(currentImage);
        // Check if viewMode is not signle
        if (this.viewMode != 'single' && nextImage) {
            // Update img src and class for nextImage
            currentImage.className = 'img-fluid w-50';
            nextImage.className = 'img-fluid w-50';
            nextImage.src = this.getImage(page + 1);
            nextImage.onload = () => {
                this.imgLoaded();
            };
            // Append nextImage based on viewMode
            if (this.viewMode == 'western') {
                n.appendChild(nextImage);
            } else {
                console.log(this.viewMode)
                n.insertBefore(nextImage, currentImage);
            }
        }
    },
    pagePadding: function (page) {
        return page.toString().padStart(2, '0');
    },
    imgIsLoading: function () {
        $('.img-loading').removeClass('d-none');
    },
    imgLoaded: function () {
        $('.img-loading').addClass('d-none');
    },
    skipHeader: function () {
        if (!PururinSetting.get('settings-scrollHeader')) return;
        window.scrollTo(0, 80);
    },
    reloadAds: function () {
        $('.oh').each(function () {
            var src = $(this).attr('src');
            $(this).attr('src', src);
        });
    }
}
window.PururinRead = PururinRead;

$(function () {
    PururinSetting.init();
    Pururin.init();
    PururinMenu.init();
    PururinGallery.init();
    PururinHotkey.init();
    PururinTag.init();
    PururinRate.init();
});
